import * as React from 'react';

const DoubleArrowChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="double-arrow-chunky_svg__eds-icon--double-arrow-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="double-arrow-chunky_svg__eds-icon--double-arrow-chunky_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 20l1.4-1.4L7.8 16H20v-2H4v1l5 5z"
        />
        <path
            id="double-arrow-chunky_svg__eds-icon--double-arrow-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 4l-1.4 1.4L16.2 8H4v2h16V9z"
        />
    </svg>
);

DoubleArrowChunkySvg.displayName = 'DoubleArrowChunkySvg';
export default DoubleArrowChunkySvg;
